export interface FeatureCardType {
  icon: React.ComponentType<{ className?: string; style?: React.CSSProperties }>
  title: string
  description: string
  accentColor: string
  bgGlow: string
}

export function FeatureCard({ feature }: { feature: FeatureCardType }) {
  return (
    <div className="group relative rounded-xl border border-border p-6">
      {/* Gradient background — dark mode only */}
      <div
        className="absolute inset-0 rounded-xl opacity-0 dark:opacity-100"
        style={{
          background: `linear-gradient(135deg, ${feature.bgGlow}, transparent 60%)`,
        }}
      />

      {/* Top accent line — dark mode only */}
      <div
        className="absolute top-0 left-6 right-6 h-px opacity-0 dark:opacity-70"
        style={{
          background: `linear-gradient(90deg, transparent, ${feature.accentColor}, transparent)`,
        }}
      />

      <div
        className="relative mb-5 flex h-10 w-10 items-center justify-center rounded-lg"
        style={{
          backgroundColor: `color-mix(in oklch, ${feature.accentColor} 15%, transparent)`,
        }}
      >
        <feature.icon className="h-5 w-5" style={{ color: feature.accentColor }} />
      </div>

      <h3 className="relative mb-2 text-base font-semibold text-foreground">{feature.title}</h3>
      <p className="relative text-sm leading-relaxed text-muted-foreground">{feature.description}</p>
    </div>
  )
}
